import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ParticlesBackground } from "@/components/ParticlesBackground";
import { CustomCursor } from "@/components/CustomCursor";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import NotFound from "@/pages/not-found";
import { MediaCMS } from "@/admin";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/admin" component={Admin} />
      <Route path="/login" component={Login} />
      <Route component={NotFound} />
    </Switch>
  );
}

/**
 * Main App with CMS route detection
 * 
 * IMPORTANT: We use window.location.pathname directly instead of wouter's useLocation()
 * because react-admin uses react-router-dom internally. If we use wouter's hook,
 * it creates a router context that conflicts with react-admin's internal router,
 * causing the error: "<Router basename="/cms"> is not able to match the URL /"
 * 
 * By checking window.location directly, react-admin gets clean control of routing.
 */
function App() {
  // Check raw URL for CMS path - don't use wouter's useLocation() here
  // to avoid router context conflicts with react-admin's react-router-dom
  const isCmsPath = typeof window !== "undefined" && window.location.pathname.startsWith("/cms");
  
  // If we're on the CMS route, render react-admin with its own routing
  if (isCmsPath) {
    return <MediaCMS />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ParticlesBackground />
        <CustomCursor />
        <ChatWidget />
        <Toaster />
        <Router />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
